import MimeTypes from "../../../models/MimeTypes";
import ImageUtils from "../../../utils/ImageUtils";
import {useEffect, useState} from "react";
import valuer_api from "../../../api/valuer";


const ValuerAmendTableScreenshotUploader = (props) => {

    // For Saving
    const summaryId = props.summaryId
    const section = props.section
    const identifier = props.identifier
    const rowIdentifier = props.rowIdentifier
    const columnIdentifier = props.columnIdentifier

    // Value
    const [newFileName, setNewFileName] = useState('')
    const [newFileBase64, setNewFileBase64] = useState('')
    const [values, setValues] = useState({})
    const [rowValues, setRowValues] = useState({})

    // Saving Tracker
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    // Error Handling
    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        if (props.rowValues !== undefined) setRowValues(props.rowValues);
    }, [props.rowValues, props.fileVersion])

    useEffect(() => {
        if (rowValues && rowValues[columnIdentifier] !== undefined) {
            let _vals = rowValues[columnIdentifier]
            // Check if contains a files info if so get its base64 string and add to dict
            if (_vals && _vals["file_path"] && _vals["file_data"] && _vals["filename"]) {
                let file_type = _vals["filename"].split(".").at(-1)
                let FILE_DATA = _vals["file_data"]
                let MIME_TYPE = MimeTypes[file_type]
                _vals["base64"] = "data:" + MIME_TYPE + ";base64," + FILE_DATA
            }
            setValues(_vals);
        }
    }, [rowValues, columnIdentifier, props.fileVersion])

    useEffect(() => {
        if (!summaryId || !section || !columnIdentifier || !rowIdentifier) return;
    }, [summaryId, section, columnIdentifier, rowIdentifier]);



    const handlePaste = async (event) => {
        if (!identifier || !columnIdentifier || !rowIdentifier) {
            console.log("Missing identifiers");
            return;
        }
        try {
            if (!navigator.clipboard) {
                // Clipboard API is restricted to HTTPS websites
                setErrorTitle("Clipboard Error")
                setErrorMessage("The Clipboard API is unavailable")
                return;
            }
            const clipboardItems = await navigator.clipboard.read();
            for (let clipboardItem of clipboardItems) {
                let imageTypes = clipboardItem.types.find(type => type.startsWith('image/'));
                if (!imageTypes) continue;
                const blob = await clipboardItem.getType(imageTypes);

                // Generate a file name and format
                let ts = Date.now()
                let fileEnding
                for (const [key, value] of Object.entries(MimeTypes))
                    if (value === imageTypes) fileEnding = "." + key
                if (!fileEnding) {
                    console.error("Unsupported file type:", imageTypes);
                    setErrorTitle("File Error")
                    setErrorMessage("The given file type is not supported")
                    break;
                }
                let filename = "paste_" + rowIdentifier + fileEnding
                setNewFileName(filename)

                // Get Base64 From BLOB
                let base64_image = await ImageUtils.convertBase64(blob);
                setNewFileBase64(base64_image)

                // Only check the first image file
                break;
            }
        } catch (err) {
            console.error("Caught error:", err);
            setErrorTitle("File Error")
            setErrorMessage("There was an error reading the image from your clipboard")
        }
    };

    /*
    TODO: This might want to be used for further local testing
    const handlePaste = async (event) => {

        if (!identifier || !columnIdentifier || !rowIdentifier) {
            return;
        }

        try {
            // Fallback clipboard access from event (works locally)
            const items = event.clipboardData?.items;
            if (!items) {
                return;
            }

            for (let i = 0; i < items.length; i++) {
                const item = items[i];

                if (item.kind === "file" && item.type.startsWith("image/")) {
                    const blob = item.getAsFile();

                    let ts = Date.now();
                    let fileEnding = "." + item.type.split("/")[1]; // crude fallback
                    let filename = "paste_" + rowIdentifier + fileEnding;

                    setNewFileName(filename);

                    let base64_image = await ImageUtils.convertBase64(blob);
                    setNewFileBase64(base64_image);

                    break;
                }
            }
        } catch (err) {
            console.error("Caught error:", err);
            setErrorTitle("File Error");
            setErrorMessage("There was an error reading the image from your clipboard");
        }
    };
*/
    const handleUploadClipboard = async (ev) => {
        if (!newFileName || !newFileBase64) return;
        let _file_object = {
            "filename": newFileName,
            "base64": newFileBase64,
        }
        AddNewFile(_file_object)
    }

    const AddNewFile = (file_object) => {
        if (!identifier || !columnIdentifier || !rowIdentifier || rowValues === undefined) return
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)

        // Add row inside the file object
        file_object["row"] = rowIdentifier;

        let body = {
            "files": [file_object]  // MUST be an array
        };

        let rv_copy = Object.assign({}, rowValues);
        rv_copy[columnIdentifier] = file_object;

        UpdateParentValue(identifier, rv_copy, rowIdentifier); // still update the external queue
        if (props.PatchLocalFileValue) {
            props.PatchLocalFileValue(rowIdentifier, columnIdentifier, file_object);
        }


        let response = valuer_api.ValuerAmendFilePut(summaryId, section, columnIdentifier, body);
        response.then(() => {
            RemoveFromQueue(section, identifier, updateTime);
        }).catch((err) => {
            AddToErroredSaves(section, identifier, updateTime);
            setErrorTitle("Failed to Save Files");
            setErrorMessage("The request to save the files has failed");
        });
    };


    return (
        <div className="valuer-amend-table-image-upload-container">
            <div className={"valuer-amend-file-upload-paste-container" +
                (rowValues && rowValues[columnIdentifier] && rowValues[columnIdentifier]["file_path"] ? " isabled" : "")}>
                        <textarea placeholder={props.placeholder || "paste screenshot here"} className="valuer-amend-field image-paste"
                                  onPaste={handlePaste} value={newFileName}/>
                <div className="valuer-amend-fil-upload-paste-button link" onClick={() => handleUploadClipboard()}>
                    >
                </div>
            </div>
        </div>
    )
}

export default ValuerAmendTableScreenshotUploader